import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { Award, Briefcase, TrendingUp } from "lucide-react";
import { SUCCESS_STATS, TESTIMONIALS, IMAGES } from "@/data/content";

export default function StudentSuccess() {
  const portfolio = [IMAGES.bridal2, IMAGES.hairUpdo, IMAGES.nail3, IMAGES.bridal4, IMAGES.hair1, IMAGES.bridal3];
  return (
    <>
      <section className="relative pt-40 pb-16 overflow-hidden">
        <div className="absolute inset-0"><img src={IMAGES.academy} alt="" className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-b from-midnight/70 to-midnight" /></div>
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <Label>Student Success</Label>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">Careers We've Built</h1>
          <p className="text-lg text-white/70 mt-6 max-w-2xl mx-auto">Real students. Real placements. Real businesses. See what's possible after training at Spunky Scissors Academy.</p>
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {SUCCESS_STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}><div className="glass rounded-lg p-7 text-center transition-colors duration-500"><div className="text-4xl gold-text font-serif">{s.value}</div><div className="font-label text-[10px] text-white/60 mt-2">{s.label}</div></div></Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle label="Student Portfolios" title="Work That Speaks" />
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {portfolio.map((img, i) => (
            <Reveal key={i}><div className="rounded-lg overflow-hidden border border-gold/20 break-inside-avoid"><img src={img} alt="Student work" className="w-full hover:scale-105 transition-transform duration-700" /></div></Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 bg-royal/20 border-y border-gold/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionTitle label="In Their Words" title="Graduate Stories" />
          <div className="grid md:grid-cols-3 gap-6">
            {TESTIMONIALS.filter((t) => t.role.includes("Graduate") || t.role.includes("Student")).concat(TESTIMONIALS.slice(0, 1)).slice(0, 3).map((t, i) => (
              <Reveal key={i} delay={i * 0.1}><div className="glass rounded-lg p-8 h-full transition-colors duration-500"><p className="text-white/80 italic leading-relaxed">"{t.text}"</p><div className="mt-5"><p className="text-gold">{t.name}</p><p className="text-white/50 text-xs">{t.role}</p></div></div></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-6">
        {[{ i: Award, t: "Certification", d: "Government-recognised certificates on completion" }, { i: Briefcase, t: "Placement Support", d: "500+ students placed in top salons" }, { i: TrendingUp, t: "Business Setup", d: "100+ alumni now run their own studios" }].map((x, k) => (
          <Reveal key={k} delay={k * 0.1}><div className="glass rounded-lg p-8 transition-colors duration-500"><x.i className="text-gold" size={28} /><h3 className="text-xl mt-4">{x.t}</h3><p className="text-white/70 text-sm mt-2">{x.d}</p></div></Reveal>
        ))}
      </section>

      <section className="py-16 text-center"><Link to="/academy" className="btn-gold" data-testid="success-apply">Start Your Journey</Link></section>
    </>
  );
}
